import { Icon } from "@circleco/compass/components/Icon";

interface DownloadButtonProps {
  url: string;
}

export const DownloadButton = ({ url }: DownloadButtonProps) => (
  <button
    type="submit"
    className="from-primary pointer-events-none absolute right-0 -my-2 hidden h-full items-center rounded-lg bg-gradient-to-l px-1 pl-36 group-hover:flex"
  >
    <a
      className="bg-primary pointer-events-auto p-2"
      href={url}
      download
      target="_blank"
      rel="noreferrer"
    >
      <Icon name="arrow-box-down" size="md" color="primary" />
    </a>
  </button>
);
